import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-toolbar py-3 py-lg-6" }
const _hoisted_2 = { class: "app-container d-flex flex-stack" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "page-title d-flex flex-column justify-content-center flex-wrap me-3" }, null, -1)
const _hoisted_4 = { class: "d-flex gap-4" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_7 = { class: "app-content flex-column-fluid" }
const _hoisted_8 = { class: "app-container" }
const _hoisted_9 = { class: "card mb-5 mb-xl-10" }
const _hoisted_10 = { class: "card-body pt-9 pb-0" }
const _hoisted_11 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = { class: "d-flex align-items-center mb-2" }
const _hoisted_14 = { class: "text-gray-900 fs-2 fw-bold me-1" }
const _hoisted_15 = { class: "d-flex flex-wrap gap-7 fw-semibold fs-6 mb-4 pe-2 mt-2" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "svg-icon svg-icon-2" }
const _hoisted_18 = { class: "text-gray-400 ms-1" }
const _hoisted_19 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold" }
const _hoisted_20 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            disabled: _ctx.loading,
            class: "btn btn-secondary align-self-center text-gray-600",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.backToList")), 1)
          ], 8, _hoisted_5)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getKycCommonTypeParams.entityType == _ctx.KycType.Juridical
                    ? _ctx.baseData.company_name
                    : _ctx.baseData.lastname + " " + _ctx.baseData.firstname), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen013.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatUtcDate(_ctx.baseData.created_at, "YYYY-MM-DD")), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("ul", _hoisted_19, [
              _createElementVNode("li", _hoisted_20, [
                _createVNode(_component_router_link, {
                  to: _ctx.goPath + '/' + _ctx.$route.params.id + '/information',
                  "active-class": "active",
                  class: "nav-link text-active-primary me-6",
                  replace: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("kyc.navigation.information")), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ]),
        _createVNode(_component_router_view, {
          loading: _ctx.loading,
          baseData: _ctx.baseData,
          onGetFormData: _ctx.getFormInfo
        }, null, 8, ["loading", "baseData", "onGetFormData"])
      ])
    ])
  ], 64))
}